import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppConfigService } from '@com-delta-idp/mnx-utils';
import { LoginModalWrapperModule } from './entry-components/login-modal-wrapper/login-modal-wrapper.module';
import { initializeAppConfigFactory } from './entry-components/login-modal/login-modal.module';
import { LoginStandaloneModule } from './entry-components/login-standalone/login-standalone.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpChallengeInterceptorService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';

@NgModule({
  imports: [CommonModule, LoginModalWrapperModule, LoginStandaloneModule],
  exports: [LoginModalWrapperModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppConfigFactory,
      deps: [AppConfigService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpChallengeInterceptorService,
      multi: true
    }
  ]
})
export class SmartModule {}
